module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Select-30d110827501023ddd304b04a6bb67cd.svg";